import { render, staticRenderFns } from "./TrainingList.vue?vue&type=template&id=9b967b8c&scoped=true"
import script from "./TrainingList.vue?vue&type=script&lang=js"
export * from "./TrainingList.vue?vue&type=script&lang=js"
import style0 from "./TrainingList.vue?vue&type=style&index=0&id=9b967b8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b967b8c",
  null
  
)

export default component.exports